export default __webpack_public_path__ + "static/media/Gotham-Bold.f86f0b82.woff2";